import axios from "axios";
export default {
    getTasksLogs: (sourceTaskIds) => axios.post("/Tasks/GetTasksLog", { sourceTaskIds })
};
